import { VectaFull } from "@/components/logos/VectaFull";
import type { AppRoutes } from "@/types/domain";
import { popupCenter } from "@/utils/popup";
import { CRM } from "@/components/logos/Crm";

const linkCls = "text-gray-500 no-underline text-[13px] leading-normal hover:text-gray-900";
const headingCls = "text-gray-900 text-xs font-bold uppercase tracking-[0.08em] m-0 p-0 mb-3";
const listCls = "list-none m-0 p-0";

type MegaFooterProps = {
  routes?: Partial<AppRoutes>;
};

export const MegaFooter = ({ routes }: MegaFooterProps) => {
  const r = {
    myDiary:           routes?.myDiary           ?? "MyDiary.aspx",
    userPreferences:   routes?.userPreferences   ?? "UserPref.aspx",
    accountSettings:   routes?.accountSettings   ?? "/AccountSettings",
    notificationsList: routes?.notificationsList ?? "NotificationsList.aspx",
  };

  return (
    <footer className="mt-auto shrink-0 bg-white border-t border-gray-200 px-5 pt-5 pb-3 md:px-10 md:pt-8 md:pb-4 print:hidden">
      <div className="flex flex-col gap-4 flex-wrap mb-3.5 md:flex-row md:gap-12 md:justify-center md:items-start">

        {/* Branding */}
        <div className="w-52 flex flex-col gap-3">
          <a
            href="https://vecta.net/en-gb/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Klipboard CRM"
            className="inline-block no-underline max-w-22"
          >
            <CRM height={28} textColor="#29335C" iconColor="#E91E8C" />
          </a>
          <p className="text-gray-700 text-[13px] font-semibold m-0 pl-1 leading-relaxed">
            Powered by{" "}
            <span className="inline-flex items-center gap-1.5 align-bottom">
              <VectaFull logoWidth={18} textClassName="text-gray-700 font-semibold text-[15px] tracking-tight" />
            </span>
            <br />Sales Analytics, BI & CRM
          </p>
        </div>

        {/* Quick Links */}
        <div className="w-36">
          <h4 className={headingCls}>Quick Links</h4>
          <ul className={listCls}>
            <li className="mb-1.5"><a href={r.myDiary} className={linkCls}>My Diary</a></li>
            <li className="mb-1.5"><a href={r.notificationsList} className={linkCls}>Notifications</a></li>
          </ul>
        </div>

        {/* My Account */}
        <div className="w-36">
          <h4 className={headingCls}>My Account</h4>
          <ul className={listCls}>
            <li className="mb-1.5"><a href={r.userPreferences} className={linkCls} onClick={(e) => { e.preventDefault(); popupCenter(r.userPreferences, "UserPreferences", 1024, 768); }}>My Preferences</a></li>
            <li className="mb-1.5"><a href={r.accountSettings} className={linkCls}>Account Settings</a></li>
          </ul>
        </div>

        {/* Support */}
        <div className="w-36">
          <h4 className={headingCls}>Support</h4>
          <ul className={listCls}>
            <li className="mb-1.5"><a href="https://vecta.net/en-gb/support-service-second-to-none" target="_blank" rel="noopener noreferrer" className={linkCls}>Support Centre</a></li>
            <li className="mb-1.5"><a href="https://vecta.net/en-gb/faqs-current-and-future-users" target="_blank" rel="noopener noreferrer" className={linkCls}>FAQs</a></li>
            <li className="mb-1.5"><a href="https://vecta.net/en-gb/contact-us" target="_blank" rel="noopener noreferrer" className={linkCls}>Contact Us</a></li>
          </ul>
        </div>

      </div>
      {/* <div className="border-t border-gray-200 pt-4 flex items-center justify-between flex-wrap gap-2">
        <p className="text-gray-400 text-xs m-0">
          &copy; {new Date().getFullYear()} Kerridge Commercial Systems Limited - Trading as Klipboard. All rights reserved.
        </p>
      </div> */}
    </footer>
  );
};
